import { useEffect } from 'react';

import { AdObj, NativeAdObj } from '../../shared/types/ast';
import { isNative } from '../utils/ast';

/**
 * Sets styling for both placement and it's container.
 * The placement is usually rendered right after the call of this hook.
 * The container is rendered a completely different place in the DOM and needs to
 * be retrieved by ID.
 */
export function usePlacementStyling(
    placementId: string,
    containerId: string,
    adObj?: AdObj,
    status?: string,
) {
    useEffect(() => {
        if (!adObj) return;

        const adIsNative = isNative(adObj as NativeAdObj);
        const searchPlacement = placementId.includes('board_');

        let className = adIsNative && searchPlacement ? '' : ' col-full-span ';
        className = status === 'failed' ? ` hidden ${className}` : className;
        // messageBus.publish(
        //     events.COMPANION.channel,
        //     events.COMPANION.AD_STYLES.topic,
        //     events.COMPANION.AD_STYLES.sendPayload({
        //         className,
        //         style: {},
        //         containerId: containerId || placementId + '--container',
        //     }),
        // );
        const container = document.getElementById(containerId);
        if (container) {
            container.className = `advt-placement relative overflow-hidden ${className}`;
        }
    }, [status, containerId, adObj, placementId]);
}
